import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { SelectRecordingType } from './types';

export function selectRecordingTypeEvent({
  type,
}: {
  type: SelectRecordingType;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.SELECT_RECORDING_TYPE,
  };

  pushToDataLayer({
    ...eventAttributes,
    type,
  });
}
